import GenericSelectionPreviewFieldView
    from "@/components/Fields/GenericFieldViews/GenericSelectionFieldView/GenericSelectionPreviewFieldView";

export default {
    extends: GenericSelectionPreviewFieldView,
    name: "Preview__MultipleSelection",
}